import { CustomizationFlagsApi } from '@frontend/api-customization-flags';
import { Icon } from '@frontend/icons';
import { useQuery } from '@frontend/react-query-helpers';
import { useLocationService } from '@frontend/wam-location-service';
import { theme } from '@frontend/theme';
import { Table, Text } from '@frontend/design-system';
import { FeatureFlagTableFilters } from './feature-flag-table-filters';

export const CustomizationFlagsTable = () => {
  const { currentLocation } = useLocationService();

  const { data } = useQuery({
    queryKey: [currentLocation?.locationId, 'customization-feature-flags'],
    queryFn: () => CustomizationFlagsApi.getCustomizationsFlagsFeaturesList(currentLocation?.locationId ?? ''),
  });

  return (
    <>
      <Table
        isPaginated
        rowSelectionConfig={{
          onSelectionToggle(selectedRows, data, selectedIds, tableInstance) {
            console.log(selectedRows, data, selectedIds, tableInstance);
          },
          hideBulkSelection: true,
        }}
        isSelectable
        data={data?.features || []}
        colConfig={[
          {
            Header: 'Feature Flag',
            id: 'featureFlag',
            accessor: (data) => data.name,
          },
          {
            Header: 'Description',
            id: 'description',
            accessor: (data) => data.description,
          },
          {
            Header: 'Status',
            id: 'status',
            accessor: (data) => (data.state === 'ACTIVE' ? 'Show' : 'Hide'),
            cellRenderer: (data) => {
              const isShow = data === 'Show';
              return (
                <Text
                  css={{
                    backgroundColor: isShow ? theme.colors.success10 : theme.colors.critical10,
                    color: isShow ? theme.colors.success50 : theme.colors.critical50,
                    padding: theme.spacing(1, 3),
                    borderRadius: theme.borderRadius.small,
                    minWidth: 85,
                    textAlign: 'center',
                  }}
                  size='medium'
                >
                  {data}
                </Text>
              );
            },
          },
          {
            Header: 'Labels',
            id: 'labels',
            accessor: () => 'Weave Elite +3',
            disableSortBy: true,
          },
        ]}
        rowActions={{
          actions: [
            {
              Icon: () => <Icon name='locations-small' />,
              label: 'Update All Locations',
              onClick: () => {
                console.log('Update All Locations');
              },
            },
            {
              Icon: () => <Icon name='edit-small' />,
              label: 'Edit Feature Flag',
              onClick: () => {
                console.log('Edit Feature Flag');
              },
            },
            {
              Icon: () => <Icon name='plus-small' />,
              label: 'Add to Group',
              onClick: () => {
                console.log('Add to Group');
              },
            },
          ],
        }}
        manualFilters
        manualFiltersRender={(modalProps, setShowNotification) => (
          <FeatureFlagTableFilters modalProps={modalProps} setShowNotificationBadge={setShowNotification} />
        )}
        hasFilterColumns
        hasGlobalSearch
        tableActions={[
          {
            Icon: () => <Icon name='update' />,
            label: 'Update',
            onClick: () => {
              console.log('Update');
            },
          },
          {
            Icon: () => <Icon name='external-link' />,
            label: 'Link',
            onClick: () => {
              console.log('Link');
            },
          },
        ]}
      ></Table>
    </>
  );
};
